import React, { Fragment, useEffect, useState, useRef } from "react";
import SaveEditFirst from "../SaveEdit/SaveEditFirst";
import TextareaSubmit from "./TextareaSubmit";
import useClickOutside from "../../../hooks/Screen/useClickOutside";
import useKeyboardShortcuts from "../../../hooks/KeysHandle/useKeyboardShortcuts";
import CreatePortalHOC from "./CreatePortalHOC";
import DatePicker from "react-datepicker";
import HyperlinkFieldsSubmit from "./HyperlinkFieldsSubmit";

const InputField = ({
  tableidclass,
  FieldType,
  FieldValue,
  FieldChange,
  setDataInputRow,
  UpdateTableField,
  Item,
  Header,
  clientCoord,
}) => {
  // console.log("headerininputfield", Header, FieldType, FieldValue);

  const [inputvalue, setInputValue] = useState("");
  const inputRef = useRef(null);
  const [overlayStyle, setOverlayStyle] = useState({});
  const [samplestate, setsamplestate] = useState(false);

  useEffect(() => {
    if (FieldType === "date" && FieldValue) {
      setInputValue(formatDateForDisplay(FieldValue));
    } else if (FieldType === "number") {
      if (FieldValue) setInputValue(parseFloat(FieldValue));
    } else {
      setInputValue(FieldValue);
    }
  }, [FieldValue, FieldType]);

  const [startDate, setStartDate] = useState(null);

  const formatDateForInput = (date) => {
    if (!date) return "";
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const formatDateForDisplay = (date) => {
    if (!date) return "";
    const [year, month, day] = date.split("-");
    return `${day}-${month}-${year}`;
  };

  const handleChange = (e) => {
    let newValue = e?.target?.value;
    // console.log("newvalue", newValue);

    if (FieldType === "date") {
      const formattedDate = formatDateForInput(e);
      setStartDate(e);
      setInputValue(formatDateForDisplay(formattedDate));
      FieldChange({ target: { value: formattedDate } });
    } else if (FieldType === "number") {
      setInputValue(newValue);
      FieldChange({ target: { value: parseFloat(newValue) } });
    } else {
      setInputValue(newValue.slice(0, 200));
      FieldChange({ target: { value: parseFloat(newValue) } });
    }
  };

  const textareaRef = useRef(null);

  const pressEnterRemotely = () => {
    console.log("outside Click hit");
    const event = new KeyboardEvent("keydown", {
      bubbles: true,
      cancelable: true,
      key: "Enter",
      code: "Enter",
      keyCode: 13,
      which: 13,
    });

    textareaRef.current.dispatchEvent(event);
  };

  useKeyboardShortcuts({
    Enter: (event) => {
      event.preventDefault();
      if (FieldType === "number") {
        UpdateTableField(event, parseFloat(inputvalue), Item, Header);
      } else {
        //console.log("inputvalue", inputvalue);

        UpdateTableField(event, inputvalue, Item, Header);
      }
    },
    Escape: (event) => {
      event.preventDefault();
      setDataInputRow(null);
    },
  });

  const inputcloseoutside = useClickOutside(() => {
    let PreviousValue;
    if (FieldType === "date" && FieldValue) {
      PreviousValue = formatDateForDisplay(FieldValue);
    } else {
      PreviousValue = FieldValue;
    }

    const normalizedPreviousValue = PreviousValue === null ? "" : PreviousValue;
    const normalizedInputValue = inputvalue === "" || !inputvalue ? "" : inputvalue;

    if (JSON.stringify(normalizedPreviousValue) !== JSON.stringify(normalizedInputValue)) {
      UpdateTableField({ stopPropagation: () => {} }, { value: inputvalue }, Item);
    } else {
      setDataInputRow(null);
    }
  });

  const getInputCoordinates = () => {
    if (inputRef.current) {
      const rect = inputRef.current.getBoundingClientRect();
      return {
        top: rect.top,
        left: rect.left,
        width: rect.width + 100,
      };
    }
    return { top: 0, left: 0, width: "auto" };
  };

  return (
    <Fragment>
      {FieldType !== "number" ? (
        <Fragment>
          {/* <div className="absolute left-1/2 transform -translate-x-1/2 z-10 mt-3 w-[300px]"> */}
          {/* <div className={`w-full absolute top-0 h-full ${HoverActiveClass}`} ref={dropdownRef} onMouseOver={handleOpen} onMouseLeave={handleClose}>
          </div> */}

          {FieldType === "date" ? (
            <Fragment>
              <SaveEditFirst
                UpdateTableField={(e) =>
                  UpdateTableField(e, { value: FieldType === "number" ? parseInt(inputvalue) : inputvalue }, Item)
                }
                handleCloseClick={(e) => {
                  e.stopPropagation();
                  setDataInputRow(null);
                }}
              />
              <div className="relative">
                <DatePicker
                  selected={startDate}
                  value={inputvalue || ""}
                  onChange={handleChange}
                  dateFormat="dd/MM/yyyy"
                  className="p-3 w-full h-[33px] "
                  // placeholderText="Select a date"
                  // isClearable
                />
                {inputvalue && (
                  <button
                    type="button"
                    onClick={() => {
                      setStartDate(null);
                      setInputValue("");
                      FieldChange({ target: { value: null } });
                    }}
                    className="absolute right-10 top-1/2 transform -translate-y-1/2 text-gray-500 hover:text-black "
                  >
                    &#x2715;
                  </button>
                )}
              </div>
            </Fragment>
          ) : (
            <>
              <input ref={inputRef} className="p-3 h-[33px]  bg-white" disabled readOnly />

              <CreatePortalHOC
                isOpen={true}
                onClose={() => {
                  pressEnterRemotely();
                }}
                position={getInputCoordinates()}
              >
                {/* <div className="table-overlay inset-0 flex items-center justify-end"> */}
                <div
                  className={` !p-0 `}
                  style={{ width: getInputCoordinates()?.width ? `${getInputCoordinates().width}px` : "auto" }}
                  ref={inputcloseoutside}
                >
                  <div className="">
                    {/* <div className="flex justify-between mb-2">
                                                                <h4 className="font-500 text-18 text-434852 capitalize">{Header?.label}</h4>
                                                                <button
                                                                onClick={(e) => {
                                                                      e.stopPropagation();
                                                                      setDataInputRow(null);
                                                                }}>
                                                                    <i className="bi bi-x-circle text-14"></i>
                                                                </button>
                                                          </div> */}

                    <TextareaSubmit
                      Value={inputvalue}
                      onChange={handleChange}
                      handleSaveEvent={(e) =>
                        UpdateTableField(e, { value: FieldType === "number" ? parseInt(inputvalue) : inputvalue }, Item)
                      }
                      textareaRef={textareaRef}
                    />
                  </div>
                </div>
                {/* </div> */}
              </CreatePortalHOC>
            </>
          )}
        </Fragment>
      ) : (
        <Fragment>
          <input
            type={FieldType === "number" ? "number" : FieldType}
            value={inputvalue}
            onChange={handleChange}
            className="p-3 w-full h-[33px]"
          />
          <SaveEditFirst
            UpdateTableField={(e) => UpdateTableField(e, parseFloat(inputvalue), Item, Header)}
            handleCloseClick={(e) => {
              e.stopPropagation();
              setDataInputRow(null);
            }}
          />
        </Fragment>
      )}
    </Fragment>
  );
};

export default InputField;
